import React, { Component, Fragment } from "react";
import EmptyState from "../../common/EmptyState";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

// expense.month looks like "April,2026" — parse into a real Date so
// months sort chronologically (newest first) instead of alphabetically.
function parseMonthId(id) {
  const [monthName, year] = String(id).split(",");
  const monthIndex = MONTH_NAMES.indexOf((monthName || "").trim());
  return new Date(parseInt(year, 10) || 0, monthIndex >= 0 ? monthIndex : 0, 1);
}

export class Datatable extends Component {
  render() {
    const { myData, history } = this.props;

    // Multiple categoryMonthlyExpense docs can exist for the same month
    // (one per distinct subCategory value ever typed for this category) —
    // merge them into a single row per month instead of showing each
    // separately.
    const byMonth = (myData || []).reduce((acc, expense) => {
      const key = expense.month;
      if (!acc[key]) acc[key] = { month: key, amount: 0 };
      acc[key].amount += parseInt(expense.amount) || 0;
      return acc;
    }, {});

    const rows = Object.values(byMonth).sort(
      (a, b) => parseMonthId(b.month) - parseMonthId(a.month)
    );

    return (
      <Fragment>
        <div className="lt-table-wrap">
          <table className="table lt-table kd-month-grid">
            <thead>
              <tr>
                <th scope="col">Month</th>
                <th scope="col">Total</th>
                <th scope="col" className="lt-col-action">Inspect</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={3} className="lt-empty">
                    <EmptyState>No records yet.</EmptyState>
                  </td>
                </tr>
              ) : (
                rows.map((expense, i) => (
                  <tr key={i}>
                    <td>{expense.month}</td>
                    <td>
                      <span className="lt-amount-pill">{expense.amount}Tk</span>
                    </td>
                    <td className="lt-col-action">
                      <button
                        type="button"
                        className="lt-icon-btn"
                        onClick={() => {
                          history.push(`/expense/lot-transport/${expense.month}`);
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
